import { snapshot } from 'valtio';
import NotificationsStore from '../stores/notification-settings-store';
import { NotificationSettings } from '../types/notification-settings-types';

export const setNotifications = (notifications: NotificationSettings[]) => {
  NotificationsStore.notifications = notifications;
};

export const setNotification = (notification: NotificationSettings) => {
  const { notifications } = snapshot(NotificationsStore);
  const updatedNotifications = notifications.map(n => {
    if (n.notificationChannelType === notification.notificationChannelType) {
      return notification;
    } else {
      return n;
    }
  });

  NotificationsStore.notifications = updatedNotifications;
};

export const setLoadingNotifications = (isLoading: boolean) => {
  NotificationsStore.isLoading = isLoading;
};

export const setErrorMessage = (message: string) => {
  NotificationsStore.errorMessage = message;
};

export const clearErrorMessage = () => {
  NotificationsStore.errorMessage = null;
};
